import {PatchAuthRequestParams} from 'domain/usecases';
import {makePatchAuthRequestStatus} from 'main/factories/usecases/private/authorizations/patch-auth-request-status-factory';

export const patchAuthRequestStatus = async (
	nuControle: string,
	params: PatchAuthRequestParams,
	signal?: AbortSignal,
) => {
	const response = await makePatchAuthRequestStatus(nuControle).patch({...params, signal});
	return response;
};
